import { defineStore } from 'pinia';

import { pinia } from './store.js';

// Повторы: колода, ответы, библиотека, вопрос по слепой зоне.
//
// Всё это данные, и по умолчанию данные живут здесь, а не в компоненте. Правило
// такое: что показывается — в сторе; что живёт ровно одну секунду и не имеет
// смысла вне экрана (микрофон, таймер, «отправляю») — в компоненте.
//
// Почему по умолчанию сюда: решение «это точно нужно только здесь» плохо
// стареет. Счётчик повторов однажды был именно таким — и оказался нужен ещё и
// в шапке проекта, где показывал устаревшее число.

export const useCards = defineStore('cards', {
  state: () => ({
    projectId: null,     // чьи это карточки: у чужого проекта свои
    mode: 'repeat',      // repeat | library | unknown
    deck: [],
    idx: 0,
    probe: null,
    library: [],
    // Черновики ответов переживают уход на другую вкладку: набранное на
    // середине мысли терять нельзя.
    drafts: {},
    results: {},
    stats: null,
    probeStats: null,
    needAgent: false,
    skipped: [],
    loading: true,
    error: '',
  }),
  actions: {
    /**
     * Другой проект — другая колода. Черновик ответа тем более: чужой текст в
     * поле выглядит как собственная забытая мысль.
     */
    open(projectId) {
      if (this.projectId === projectId) return;
      this.projectId = projectId;
      this.reset();
      this.library = [];
      this.probe = null;
      this.stats = null;
      this.probeStats = null;
      this.needAgent = false;
      this.error = '';
      this.loading = true;
    },

    reset() {
      this.deck = [];
      this.idx = 0;
      this.results = {};
      this.drafts = {};
      this.skipped = [];
    },
  },
});

export const cards = useCards(pinia);
